import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { User } from '../_models/user';
import { AuthService } from '../_services/auth.service';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { UserService } from '../admin/_services/user.service';
import { SettingService } from '../admin/_services/setting.service';
import { Setting } from '../_models/setting';
import { RoleService } from '../admin/_services/role.service';
import { Role } from '../_models/role';
import { forEachChild } from 'typescript';

@Component({
   selector: 'app-nav',
   templateUrl: './nav.component.html',
   styleUrls: ['./nav.component.scss'],
   styles: [
      `
         .bg-dangerAnim {
            background-color: #ff4c4c;
         }
         .animate-bg {
            animation: darkenLighten 2s infinite;
         }
         @keyframes darkenLighten {
            0% {
               background-color: #ff4c4c;
            }
            50% {
               background-color: #b22222;
            }
            100% {
               background-color: #ff4c4c;
            }
         }
      `,
   ],
})
export class NavComponent implements OnInit {
   user: User;
   roles: Role[];
   baseUrl = environment.apiUrl;
   profilePic: string;
   integrateWith = false;
   showMenu = true;
   licenseBad = true;
   licenseWarn = false;
   licenseGood = false;
   licenseDays = 0;

   constructor(
      private authService: AuthService,
      private routerService: Router,
      private userService: UserService,
      private settingService: SettingService,
      private el: ElementRef,
      private renderer: Renderer2
   ) {
      // window.addEventListener('message', this.handlePortalMessage.bind(this));
   }

   private handlePortalMessage(event: MessageEvent) {
      var navUrl = event.data.payload.url.substring(2);

      if (navUrl == '/menu' && !this.showMenu) {
         navUrl = '/';
         this.showMenu = true;
         var menuArray = [];
         menuArray.push({
            caption: 'Use Portal Menu',
            icon: 'far fa-fw fa-cogs',
            url: '/menu',
            children: [],
         });
         menuArray.push({
            caption: 'Home',
            icon: 'far fa-fw fa-home',
            url: '/',
            children: [],
         });
         const jsonResult = { type: 'setMenu', payload: { menu: menuArray } };
         window.parent.postMessage(jsonResult, '*');
         this.routerService.navigate([navUrl]);
         return;
      }

      if (navUrl == '/menu' && this.showMenu) {
         navUrl = '/';
         this.showMenu = false;
         this.setupMenuForPortal();
         this.routerService.navigate([navUrl]);
         return;
      }

      this.routerService.navigate([navUrl]);
   }

   ngOnInit() {
      this.user = this.authService.currentUser;

      // if (self != top) {    ---------------- Disabled portal menu ----------------
      //    // this.showMenu = false;
      //    // this.setupMenuForPortal();
      // }

      this.profilePic = 'user/photo/' + this.user?.id + '?' + new Date().getTime();

      this.settingService.getSetting('INTEGRATEWITH').subscribe((settingData: Setting) => {
         if (settingData.settingValue === 'Normal') this.integrateWith = true;
      });

      this.userService.AvatarChanged.subscribe((s: string) => {
         if (s) {
            this.profilePic = 'user/photo/' + this.user.id + '?' + new Date().getTime();
            localStorage.setItem('user', JSON.stringify(this.user));
         } else {
            this.profilePic = this.authService.currentUser.url;
         }
      });

      this.authService.checkSiteExpired().subscribe((data) => {
         this.licenseDays = data['remainingLicenseDays'];
         if (this.licenseDays > 9) {
            this.licenseBad = false;
            this.licenseWarn = true;
         }
         if (this.licenseDays > 99) {
            this.licenseBad = false;
            this.licenseWarn = false;
            this.licenseGood = true;
         }
      });
   }
   
   closeLogoEdit(s: string): void {
      if (s) {
         this.profilePic = 'user/photo/' + this.user.id + '?' + new Date().getTime();
      }
   }
   logout() {
      this.authService.logout();
      this.routerService.navigate(['/login']);
   }

   setupMenuForPortal() {
      window.parent.postMessage(this.parseMenu(), '*');
   }

   parseMenu(): any {
      var menuArray = [];
      var childItemArrayA = [];
      var childItemArrayB = [];
      var childItemArrayC = [];

      menuArray.push({
         caption: 'Use Integrated Menu',
         icon: 'far fa-fw fa-cogs',
         url: '/menu',
         children: [],
      });

      menuArray.push({
         caption: 'Home',
         icon: 'far fa-fw fa-home',
         url: '/',
         children: [],
      });

      if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
         menuArray.push({
            caption: 'Settings',
            icon: 'far fa-fw fa-cog',
            url: '/admin/setting',
            children: [],
         });
      }

      // ============================================================ Admin ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'USR-VW', 'RLE-VW', 'ERR-VW', 'RPT-VW', 'RN-VW'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'USR-VW'])) {
            childItemArrayA.push({
               caption: 'Users',
               icon: 'far fa-fw fa-user',
               url: '/admin/user',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'USR-VW'])) {
            childItemArrayA.push({
               caption: 'Users',
               icon: 'far fa-fw fa-user',
               url: '/admin/custodian',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RLE-VW'])) {
            childItemArrayA.push({
               caption: 'Roles',
               icon: 'far fa-fw fa-users',
               url: '/admin/role',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ERR-VW', 'ERR-PR'])) {
            childItemArrayA.push({
               caption: 'System Errors',
               icon: 'far fa-fw fa-exclamation-circle',
               url: '/admin/errorlog',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayA.push({
               caption: 'Audit Log',
               icon: 'far fa-fw fa-pen',
               url: '/admin/auditlog',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RPT-VW', 'RPT-PR'])) {
            childItemArrayA.push({
               caption: 'Reports',
               icon: 'far fa-fw fa-print',
               url: '/admin/reportdashboard',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RN-VW', 'RN-PR'])) {
            childItemArrayA.push({
               caption: 'Release Notes',
               icon: 'far fa-fw fa-clipboard',
               url: '/admin/releasenotes',
            });
         }
         menuArray.push({
            caption: 'Admin',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });
         childItemArrayA = [];
      }

      // ============================================================ Setup ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BA-VW', 'CC-VW', 'DIM-VW', 'SUP-VW', 'STE-VW', 'BLD-VW', 'ROOM-VW'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BA-VW'])) {
            childItemArrayA.push({
               caption: 'Business Area',
               icon: 'far fa-fw fa-clone',
               url: '/setup/businessarea',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'CC-VW'])) {
            childItemArrayA.push({
               caption: 'Cost Centre',
               icon: 'far fa-fw fa-coins',
               url: '/setup/costcentre',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'DIM-VW'])) {
            childItemArrayA.push({
               caption: 'Dimensions',
               icon: 'far fa-fw fa-cubes',
               url: '/setup/dimension',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'SUP-VW'])) {
            childItemArrayA.push({
               caption: 'Supplier',
               icon: 'far fa-fw fa-hand-holding-usd',
               url: '/setup/supplier',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'STE-VW'])) {
            childItemArrayB.push({
               caption: 'Sites',
               icon: 'far fa-fw fa-flag',
               url: '/setup/site',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BLD-VW'])) {
            childItemArrayB.push({
               caption: 'Buildings',
               icon: 'far fa-fw fa-building',
               url: '/setup/building',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ROOM-VW'])) {
            childItemArrayB.push({
               caption: 'Rooms',
               icon: 'far fa-fw fa-home',
               url: '/setup/room',
            });
         }

         menuArray.push({
            caption: 'Setup',
            icon: 'far fa-fw fa-folder',
            children: [
               {
                  caption: 'General Setup',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayA,
               },
               {
                  caption: 'Location Setup',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayB,
               },
            ],
         });
         childItemArrayA = [];
         childItemArrayB = [];
      }

      // ============================================================ Classification Setup ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'CLASS-VW', 'ACC-VW', 'AGR-VW', 'ATP-VW', 'CTP-VW', 'DTP-VW', 'ATB-VW', 'GLA-VW', 'WTP-VW', 'WTV-VW', 'WTR-VW', 'WTR-PR'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'AGR-VW'])) {
            childItemArrayA.push({
               caption: 'Asset Group',
               icon: 'far fa-fw fa-cogs',
               url: '/setupclass/assetgroup',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ATP-VW'])) {
            childItemArrayA.push({
               caption: 'Asset Type',
               icon: 'far fa-fw fa-tools',
               url: '/setupclass/assettype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'CTP-VW'])) {
            childItemArrayA.push({
               caption: 'Component Type',
               icon: 'far fa-fw fa-cogs',
               url: '/setupclass/componenttype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'DTP-VW'])) {
            childItemArrayA.push({
               caption: 'Descriptor Type',
               icon: 'far fa-fw fa-atom',
               url: '/setupclass/descriptortype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ATB-VW'])) {
            childItemArrayA.push({
               caption: 'Attributes',
               icon: 'far fa-fw fa-cogs',
               url: '/setupclass/attribute',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'GLA-VW'])) {
            childItemArrayA.push({
               caption: 'GL Accounts',
               icon: 'far fa-fw fa-cogs',
               url: '/setupclass/account',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayB.push({
               caption: 'Type',
               icon: 'far fa-fw fa-clone',
               url: '/setupclass/wat-type',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTV-VW'])) {
            childItemArrayB.push({
               caption: 'Version',
               icon: 'far fa-fw fa-coins',
               url: '/setupclass/wat-version',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTR-VW', 'WTR-PR'])) {
            childItemArrayB.push({
               caption: 'WAT Register',
               icon: 'far fa-fw fa-chart-line',
               url: '/setupclass/wat-register',
            });
         }

         menuArray.push({
            caption: 'Classification Setup',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });
         childItemArrayA = [];
      }

      // ============================================================ Asset Management ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'FAR-EX', 'INT-VW', 'CJRL-VW', '3RD-EXP', 'DIM-C-VW', 'CC-C-VW', 'CLASS-C-V', 'BAR-REP-VW', 'HIS-VW'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'FAR-EX', 'INT-VW'])) {
            childItemArrayA.push({
               caption: 'Asset Register',
               icon: 'far fa-fw fa-chart-line',
               url: '/assetmanagement/asset/register',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-VW', 'CJRL-VW'])) {
            childItemArrayA.push({
               caption: 'Correction Journals',
               icon: 'far fa-fw fa-check-circle',
               url: '/assetmanagement/asset/correctionjournalintegration',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', '3RD-EXP'])) {
            childItemArrayA.push({
               caption: '3rd Party Exports',
               icon: 'far fa-fw fa-cogs',
               url: '/assetmanagement/asset/exportthirdparty',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'DIM-C-VW'])) {
            childItemArrayA.push({
               caption: 'Dimension Change',
               icon: 'far fa-fw fa-layer-group',
               url: '/assetmanagement/asset/dimensionchange',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'CC-C-VW'])) {
            childItemArrayA.push({
               caption: 'Cost Centre Change',
               icon: 'far fa-fw fa-coins',
               url: '/assetmanagement/asset/costcentrechange',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'CLASS-C-V'])) {
            childItemArrayA.push({
               caption: 'Classification Change',
               icon: 'far fa-fw fa-cogs',
               url: '/assetmanagement/asset/classificationchange',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BAR-REP-VW'])) {
            childItemArrayA.push({
               caption: 'Barcode Replacement',
               icon: 'far fa-fw fa-barcode',
               url: '/assetmanagement/asset/barcodereplacement',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'HIS-VW'])) {
            childItemArrayA.push({
               caption: 'Transaction History',
               icon: 'far fa-fw fa-history',
               url: '/assetmanagement/asset/transactionhistory',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-CNL'])) {
            childItemArrayA.push({
               caption: 'Remove Bulk Assets',
               icon: 'far fa-fw fa-trash',
               url: '/assetmanagement/asset/removebulk',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'General',
               icon: 'far fa-fw fa-cogs',
               url: 'assetmanagement/asset/general/GENERAL',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Vehicle',
               icon: 'far fa-fw fa-truck',
               url: 'assetmanagement/asset/vehicle/VEHICLE',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Road',
               icon: 'far fa-fw fa-road',
               url: '/assetmanagement/asset/road/ROAD',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Land',
               icon: 'far fa-fw fa-tree',
               url: '/assetmanagement/asset/land/LAND',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Building',
               icon: 'far fa-fw fa-building',
               url: '/assetmanagement/asset/building/BUILDING',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Water',
               icon: 'far fa-fw fa-bath',
               url: '/assetmanagement/asset/water/WATER',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Storm Water',
               icon: 'far fa-fw fa-water',
               url: '/assetmanagement/asset/stormwater/STORMWATER',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Sanitation',
               icon: 'far fa-fw fa-toilet-paper',
               url: '/assetmanagement/asset/sanitation/SANITATION',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Electricity',
               icon: 'far fa-fw fa-lightbulb',
               url: '/assetmanagement/asset/electricity/ELECTRICITY',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ASSET-VW'])) {
            childItemArrayB.push({
               caption: 'Railway',
               icon: 'far fa-fw fa-train',
               url: '/assetmanagement/asset/railway/RAILWAY',
            });
         }

         childItemArrayA.push({
            caption: 'Groups',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayB,
         });

         menuArray.push({
            caption: 'Asset Management',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         childItemArrayA = [];
         childItemArrayB = [];
      }

      // ============================================================ Transactions ============================================================
      if (
         this.authService.roleMatch([
            'SYSTEM-ADMIN',
            'M-END-RUN',
            'M-END-AP',
            'M-END-RB',
            'M-END-RP',
            'M-END-PR',
            'RECON-VW',
            'RECON-PR',
            'DEP-RUN',
            'PU-VW',
            'FOR-EXP',
            'ACQ-VW',
            'DISP-VW',
            'RULC-VW',
            'RULC-VW',
            'UPG-VW',
            'IMP-VW',
            'REV-VW',
            'ADJ-VW',
            'J-ADJ-VW',
            'TRAN-RP',
            'TRAN-PR',
         ])
      ) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'M-END-RUN', 'M-END-AP', 'M-END-RB', 'M-END-RP', 'M-END-PR'])) {
            childItemArrayA.push({
               caption: 'Month End',
               icon: 'far fa-fw fa-running',
               url: '/financialTransaction/monthend',
            });
            childItemArrayA.push({
               caption: 'Year End',
               icon: 'far fa-fw fa-running',
               url: '/financialTransaction/yearend',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'DEP-RUN', 'PU-VW', 'FOR-EXP'])) {
            childItemArrayA.push({
               caption: 'Reconciliations',
               icon: 'far fa-fw fa-balance-scale',
               url: '/financialTransaction/reconciliation',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'DEP-RUN'])) {
            childItemArrayB.push({
               caption: 'Run Monthly',
               icon: 'far fa-fw fa-running',
               url: '/financialTransaction/depreciation',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'PU-VW'])) {
            childItemArrayB.push({
               caption: 'Production Of Unit',
               icon: 'far fa-fw fa-truck-moving',
               url: '/financialTransaction/depreciation/productionofunit',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'FOR-EXP'])) {
            childItemArrayB.push({
               caption: 'Forecast',
               icon: 'far fa-fw fa-chart-line',
               url: '/financialTransaction/depreciationforecast',
            });
         }

         if (
            this.authService.roleMatch(['SYSTEM-ADMIN', 'TRANSACTIONS-TRANSACTIONS-BUDGETING-CREATE', 'BUD-AP', 'BUD-ED', 'TRANSACTIONS-TRANSACTIONS-BUDGETING-CANCEL', 'BUD-VW'])
         ) {
            childItemArrayD.push({
               caption: 'Budget',
               icon: 'far fa-fw fa-cubes',
               url: '/financialTransaction/budget',
            });
         }

         childItemArrayC.push({
            caption: 'Month/Year End',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });
         childItemArrayC.push({
            caption: 'Depreciation',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayB,
         });
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ACQ-VW'])) {
            childItemArrayC.push({
               caption: 'Acquisitions',
               icon: 'far fa-fw fa-credit-card',
               url: '/financialTransaction/acquisition',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'DISP-VW'])) {
            childItemArrayC.push({
               caption: 'Disposals',
               icon: 'far fa-fw fa-recycle',
               url: '/financialTransaction/disposal',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RULC-VW'])) {
            childItemArrayC.push({
               caption: 'Rul Changes',
               icon: 'far fa-fw fa-hourglass',
               url: '/financialTransaction/rulchange',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RULC-VW'])) {
            childItemArrayC.push({
               caption: 'Residual Changes',
               icon: 'far fa-fw fa-coins',
               url: '/financialTransaction/residualchange',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'UPG-VW'])) {
            childItemArrayC.push({
               caption: 'Upgrades',
               icon: 'far fa-fw fa-redo',
               url: '/financialTransaction/upgrade',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'IMP-VW'])) {
            childItemArrayC.push({
               caption: 'Impairments',
               icon: 'far fa-fw fa-hand-point-down',
               url: '/financialTransaction/impairment',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'REV-VW'])) {
            childItemArrayC.push({
               caption: 'Revaluations',
               icon: 'far fa-fw fa-money-bill-wave',
               url: '/financialTransaction/revaluation',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'ADJ-VW'])) {
            childItemArrayC.push({
               caption: 'Adjustments',
               icon: 'far fa-fw fa-adjust',
               url: '/financialTransaction/adjustment',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'TRAN-RP', 'TRAN-PR'])) {
            childItemArrayC.push({
               caption: 'Reports',
               icon: 'far fa-fw fa-print',
               url: '/financialTransaction/reportdashboard',
            });
         }

         menuArray.push({
            caption: 'Transactions',
            icon: 'far fa-fw fa-folder',
            children: [
               {
                  caption: 'Month/Year End',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayA,
               },
               {
                  caption: 'Budgeting',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayD,
               },
               {
                  caption: 'Depreciation',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayB,
               },
               childItemArrayC,
            ],
         });

         childItemArrayA = [];
         childItemArrayB = [];
         childItemArrayC = [];
         childItemArrayD = [];
      }

      // ============================================================ Wear and Tear ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW', 'WTV-VW', 'WTR-VW', 'WTR-PR'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Type',
               icon: 'far fa-fw fa-clone',
               url: '/setupclass/wat-type',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTV-VW'])) {
            childItemArrayA.push({
               caption: 'Version',
               icon: 'far fa-fw fa-coins',
               url: '/setupclass/wat-version',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTR-VW', 'WTR-PR'])) {
            childItemArrayA.push({
               caption: 'WAT Register',
               icon: 'far fa-fw fa-chart-line',
               url: '/setupclass/wat-register',
            });
         }
         menuArray.push({
            caption: 'Wear and Tear',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });
         childItemArrayA = [];
      }

      // ============================================================ Work in Progress ============================================================
      if (
         this.authService.roleMatch([
            'SYSTEM-ADMIN',
            'WIP-EN-VW',
            'WIP-CO-VW',
            'WIP-FU-VW',
            'WIP-QST-VW',
            'WIP-TMP-VW',
            'WIP-PR-VW',
            'WIP-TR-VW',
            'WIP-AL-VW',
            'WIP-MA-VW',
            'WIP-RP',
            'WIP-PR',
         ])
      ) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-EN-VW'])) {
            childItemArrayA.push({
               caption: 'Engineers',
               icon: 'far fa-fw fa-pencil-ruler',
               url: '/wip/engineer',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-CO-VW'])) {
            childItemArrayA.push({
               caption: 'Contractors',
               icon: 'far fa-fw fa-hard-hat',
               url: '/wip/contractor',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-FU-VW'])) {
            childItemArrayA.push({
               caption: 'Fund',
               icon: 'far fa-fw fa-university',
               url: '/wip/fund',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-QST-VW'])) {
            childItemArrayB.push({
               caption: 'Questions',
               icon: 'far fa-fw fa-question-circle',
               url: '/wip/question',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-TMP-VW'])) {
            childItemArrayB.push({
               caption: 'Checklist Template',
               icon: 'far fa-fw fa-clipboard-list',
               url: '/wip/checklisttemplate',
            });
         }

         childItemArrayA.push({
            caption: 'Checklist Setup',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayB,
         });

         childItemArrayC.push({
            caption: 'Setup',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-PR-VW'])) {
            childItemArrayC.push({
               caption: 'Project',
               icon: 'far fa-fw fa-project-diagram',
               url: '/wip/project',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-CE-VW'])) {
            childItemArrayC.push({
               caption: 'Certificate',
               icon: 'far fa-fw fa-certificate',
               url: '/wip/certificate',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-TR-VW'])) {
            childItemArrayC.push({
               caption: 'Transaction',
               icon: 'far fa-fw fa-money-bill',
               url: '/wip/transaction',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-AL-VW'])) {
            childItemArrayC.push({
               caption: 'Allocation Adjustment',
               icon: 'far fa-fw fa-money-bill-alt',
               url: '/wip/allocationAdjustment',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-MA-VW'])) {
            childItemArrayC.push({
               caption: 'Master Asset',
               icon: 'far fa-fw fa-truck-monster',
               url: '/wip/masterAsset',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WIP-RP', 'WIP-PR'])) {
            childItemArrayC.push({
               caption: 'Reports',
               icon: 'far fa-fw fa-project-diagram',
               url: '/wip/reportdashboard1',
            });
         }

         menuArray.push({
            caption: 'Work in Progress',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayC,
         });

         childItemArrayA = [];
         childItemArrayB = [];
         childItemArrayC = [];
      }

      // ============================================================ Lease Management ============================================================

      // TODO: Rikus - add lease management roles
      if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Lease Agreements',
               icon: 'fa fas fa-balance-scale',
               url: '/leaseManagement/leaseAgreement',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Additional Payments',
               icon: 'fa fas fa-credit-card',
               url: '/leaseManagement/leaseAgreement/additionalPayment',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Interest Rate Change',
               icon: 'fa fas fa-chart-line',
               url: '/leaseManagement/leaseAgreement/interestRateChanges',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Interest Adjustment',
               icon: 'fa fas fa-chart-line',
               url: '/leaseManagement/leaseAgreement/interestBalanceChanges',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Contract Fees',
               icon: 'fa fa-money-bill-wave',
               url: '/leaseManagement/leaseAgreement/contractFees',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Monthly Contract Fees',
               icon: 'fa fa-coins',
               url: '/leaseManagement/leaseAgreement/monthlyContractFees',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTP-VW'])) {
            childItemArrayA.push({
               caption: 'Take On',
               icon: 'fa fa-sliders-h',
               url: '/leaseManagement/leaseAgreement/takeon',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTV-VW'])) {
            childItemArrayA.push({
               caption: 'Lease Agreement Journals',
               icon: 'far fa-fw fa-running',
               url: '/leaseManagement/leaseAgreementJournal',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTV-VW'])) {
            childItemArrayB.push({
               caption: 'Sales Lease Agreements',
               icon: 'fa fas fa-balance-scale',
               url: '/leaseManagement/leaseAgreementSales',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WTV-VW'])) {
            childItemArrayB.push({
               caption: 'Penalty Fees',
               icon: 'fa fa-coins mr-2',
               url: '/leaseManagement/leaseAgreementSales/penaltyFees',
            });
         }

         menuArray.push({
            caption: 'Lease Management',
            icon: 'far fa-fw fa-folder',
            children: [
               {
                  caption: 'Lease Management',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayA,
               },
               {
                  caption: ' Sales Lease Management',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayB,
               },
            ],
         });
         childItemArrayA = [];
         childItemArrayB = [];
      }

      // ============================================================ Scanned Assets ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'SCN-PR-VW', 'SCN-CON-VW', 'SCN-VW', 'SCN-DP-VW'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'SCN-PR-VW'])) {
            childItemArrayA.push({
               caption: 'Scan Project',
               icon: 'far fa-fw fa-project-diagram',
               url: '/scan/scanproject',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'SCN-CON-VW'])) {
            childItemArrayA.push({
               caption: 'Condition Assessment Setup',
               icon: 'far fa-fw fa-clipboard-check',
               url: '/conditionAssesment/condition',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'SCN-VW'])) {
            childItemArrayA.push({
               caption: 'Scanned Items',
               icon: 'far fa-fw fa-tasks',
               url: '/scan/inventorylist',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'SCN-DP-VW'])) {
            childItemArrayA.push({
               caption: 'Scanned Items Dump',
               icon: 'far fa-fw fa-layer-group',
               url: '/scan/dumpinventorylist',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'SCN-RP', 'SCN-PR'])) {
            childItemArrayA.push({
               caption: 'Reports',
               icon: 'far fa-fw fa-print',
               url: '/scan/reportdashboard',
            });
         }

         menuArray.push({
            caption: 'Scanned Assets',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         childItemArrayA = [];
      }

      // ============================================================ RFID Tracking ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RFID-Z-VW', 'RFID-R-VW', 'RFIDR-LOG-VW', 'RFIDR-LOG-PR', 'RFID-M-VW', 'RFID-SEC-VW', 'RFID-ERR-VW', 'RFID-ERR-PR'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RFID-Z-VW'])) {
            childItemArrayA.push({
               caption: 'Zones',
               icon: 'far fa-fw fa-tasks',
               url: '/rfid/zone',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RFID-R-VW'])) {
            childItemArrayA.push({
               caption: 'Readers',
               icon: 'far fa-fw fa-clone',
               url: '/rfid/reader',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RFIDR-LOG-VW', 'RFIDR-LOG-PR'])) {
            childItemArrayA.push({
               caption: 'Read Log',
               icon: 'far fa-fw fa-folder',
               url: '/rfid/readlog',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RFID-M-VW'])) {
            childItemArrayA.push({
               caption: 'Movements',
               icon: 'far fa-fw fa-bars',
               url: '/rfid/movement/false',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RFID-SEC-VW'])) {
            childItemArrayA.push({
               caption: 'Security Movements',
               icon: 'far fa-fw fa-home',
               url: '/rfid/securitymovement/true',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'RFID-ERR-VW', 'RFID-ERR-PR'])) {
            childItemArrayA.push({
               caption: 'Error Log',
               icon: 'far fa-fw fa-exclamation-circle',
               url: '/rfid/errorlog',
            });
         }

         menuArray.push({
            caption: 'RFID Tracking',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         childItemArrayA = [];
      }

      // ============================================================ Geograpical Info ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'GEO-R-VW', 'GEO-L-VW', 'GEO-LT-VW', 'GEO-VW'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'GEO-R-VW'])) {
            childItemArrayA.push({
               caption: 'Regions',
               icon: 'far fa-fw fa-map-pin',
               url: '/gis/region',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'GEO-L-VW'])) {
            childItemArrayA.push({
               caption: 'Layers',
               icon: 'far fa-fw fa-layer-group',
               url: '/gis/layer',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'GEO-LT-VW'])) {
            childItemArrayA.push({
               caption: 'Layers Per Type',
               icon: 'far fa-fw fa-layer-group',
               url: '/gis/layertype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'GEO-VW'])) {
            childItemArrayA.push({
               caption: 'Geo Assets',
               icon: 'far fa-fw fa-map-marked-alt',
               url: '/gis/map',
            });
         }

         menuArray.push({
            caption: 'Geographical Info',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         childItemArrayA = [];
      }

      // ============================================================ Monitoring ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MON-VW', 'MON-LOS-VW', 'MON-MV-VW', 'MON-MVAR-VW'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MON-VW'])) {
            childItemArrayA.push({
               caption: 'Dashboard',
               icon: 'far fa-fw fa-tachometer-alt',
               url: '/monitoring/dashboard',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MON-LOS-VW'])) {
            childItemArrayB.push({
               caption: 'Lost/Stolen Assets',
               icon: 'far fa-fw fa-trash-alt',
               url: 'monitoring/list/loss',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MON-MV-VW'])) {
            childItemArrayC.push({
               caption: 'New Movements',
               icon: 'far fa-fw fa-project-diagram',
               url: '/monitoring/assetmovement',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MON-MVAR-VW'])) {
            childItemArrayC.push({
               caption: 'Archive',
               icon: 'far fa-fw fa-box-open',
               url: '/monitoring/assetmovementarc',
            });
         }

         childItemArrayA.push({
            caption: 'Monitoring Actions',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayB,
         });
         childItemArrayA.push({
            caption: 'Asset Movements',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayC,
         });

         menuArray.push({
            caption: 'Monitoring',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         childItemArrayA = [];
         childItemArrayB = [];
         childItemArrayC = [];
      }

      // ============================================================ Maintenance ============================================================
      if (
         this.authService.roleMatch([
            'SYSTEM-ADMIN',
            'MTC-ALL-MANAGER',
            'MTC-LRT-CR',
            'MTC-LRT-AP',
            'MTC-LRT-ED',
            'MTC-LRT-DL',
            'MTC-LRT-VW',
            'MTC-LR-CR',
            'MTC-LR-AP',
            'MTC-LR-ED',
            'MTC-LR-DL',
            'MTC-LR-VW',
            'MTC-ADJ-CR',
            'MTC-ADJ-AP',
            'MTC-ADJ-ED',
            'MTC-ADJ-DL',
            'MTC-ADJ-VW',
            'MTC-RT-CR',
            'MTC-RT-AP',
            'MTC-RT-ED',
            'MTC-RT-DL',
            'MTC-RT-VW',
            'MTC-AR-CR',
            'MTC-AR-AP',
            'MTC-AR-ED',
            'MTC-AR-DL',
            'MTC-AR-VW',
            'MTC-ASR-CR',
            'MTC-ASR-AP',
            'MTC-ASR-ED',
            'MTC-ASR-DL',
            'MTC-ASR-VW',
            'MTC-TRT-CR',
            'MTC-TRT-AP',
            'MTC-TRT-ED',
            'MTC-TRT-DL',
            'MTC-TRT-VW',
            'MTC-TR-CR',
            'MTC-TR-AP',
            'MTC-TR-ED',
            'MTC-TR-DL',
            'MTC-TR-VW',
            'MTC-ATR-CR',
            'MTC-ATR-AP',
            'MTC-ATR-ED',
            'MTC-ATR-DL',
            'MTC-ATR-VW',
            'MTC-AT-CR',
            'MTC-AT-AP',
            'MTC-AT-ED',
            'MTC-AT-DL',
            'MTC-AT-VW',
            'MTC-STR-VW',
            'MTC-TEN-CR',
            'MTC-TEN-AP',
            'MTC-TEN-ED',
            'MTC-TEN-DL',
            'MTC-TEN-VW',
            'MTC-TM-CR',
            'MTC-TM-AP',
            'MTC-TM-ED',
            'MTC-TM-DL',
            'MTC-TM-VW',
            'MTC-WH-CR',
            'MTC-WH-AP',
            'MTC-WH-ED',
            'MTC-WH-DL',
            'MTC-WH-VW',
            'MTC-ST-CR',
            'MTC-ST-AP',
            'MTC-ST-ED',
            'MTC-ST-DL',
            'MTC-ST-VW',
            'MTC-IS-CR',
            'MTC-IS-AP',
            'MTC-IS-ED',
            'MTC-IS-DL',
            'MTC-IS-VW',
            'MTC-RO-CR',
            'MTC-RO-AP',
            'MTC-RO-ED',
            'MTC-RO-DL',
            'MTC-RO-VW',
            'MTC-BI-CR',
            'MTC-BI-AP',
            'MTC-BI-ED',
            'MTC-BI-DL',
            'MTC-BI-VW',
            'MTC-PC-CR',
            'MTC-PC-AP',
            'MTC-PC-ED',
            'MTC-PC-DL',
            'MTC-PC-VW',
            'MTC-PRT-CR',
            'MTC-PRT-AP',
            'MTC-PRT-ED',
            'MTC-PRT-DL',
            'MTC-PRT-VW',
            'MTC-PRT-REC',
            'MTC-REQ-CR',
            'MTC-REQ-AP',
            'MTC-REQ-ED',
            'MTC-REQ-DL',
            'MTC-REQ-VW',
            'MTC-RET-VW',
            'MTC-RET-COLL',
            'MTC-RET-RET',
            'MTC-UPS-COMP',
            'MTC-UPS-ED',
            'MTC-UPS-DL',
            'MTC-UPS-VW',
            'MTC-ATRT-ADD',
            'MTC-ATRT-REM',
            'MTC-ATRT-VW',
            'MTC-WOR-CR',
            'MTC-WOR-AP',
            'MTC-WOR-ED',
            'MTC-WOR-DL',
            'MTC-WOR-VW',
            'MTC-WOA-CR',
            'MTC-WOA-AP',
            'MTC-WOA-ED',
            'MTC-WOA-DL',
            'MTC-WOA-VW',
            'MTC-WOT-CR',
            'MTC-WOT-VW',
            'MTC-WO-CR',
            'MTC-WO-ED',
            'MTC-WO-VW',
            'MTC-WO-SCHED',
            'MTC-WOS-CR',
            'MTC-WOS-ED',
            'MTC-WOS-VW',
            'MTC-WOP-VW',
            'MTC-MYWO-VW',
            'MTC-JOBA-CR',
            'MTC-JOBA-AP',
            'MTC-JOBA-ED',
            'MTC-JOBA-DL',
            'MTC-JOBA-VW',
            'MTC-RP',
            'MTC-PR',
         ])
      ) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-LRT-CR', 'MTC-LRT-AP', 'MTC-LRT-ED', 'MTC-LRT-DL', 'MTC-LRT-VW'])) {
            childItemArrayA.push({
               caption: 'Labour Resource Type',
               icon: 'far fa-fw fa-users-cog',
               url: '/maintenance/labourresourcetype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-LR-CR', 'MTC-LR-AP', 'MTC-LR-ED', 'MTC-LR-DL', 'MTC-LR-VW'])) {
            childItemArrayA.push({
               caption: 'Labour Resource',
               icon: 'far fa-fw fa-users',
               url: '/maintenance/labourresource',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-ADJ-CR', 'MTC-ADJ-AP', 'MTC-ADJ-ED', 'MTC-ADJ-DL', 'MTC-ADJ-VW'])) {
            childItemArrayA.push({
               caption: 'Adjust Labour Rate',
               icon: 'far fa-fw fa-people-arrows',
               url: '/maintenance/adjustlabourresource',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-RT-CR', 'MTC-RT-AP', 'MTC-RT-ED', 'MTC-RT-DL', 'MTC-RT-VW'])) {
            childItemArrayB.push({
               caption: 'Asset Resource Type',
               icon: 'far fa-fw fa-truck',
               url: '/maintenance/resourcetype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-AR-CR', 'MTC-AR-AP', 'MTC-AR-ED', 'MTC-AR-DL', 'MTC-AR-VW'])) {
            childItemArrayB.push({
               caption: 'Asset Resource',
               icon: 'far fa-fw fa-truck-pickup',
               url: '/maintenance/resource',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-ASR-CR', 'MTC-ASR-AP', 'MTC-ASR-ED', 'MTC-ASR-DL', 'MTC-ASR-VW'])) {
            childItemArrayB.push({
               caption: 'Adjust Resource Rate',
               icon: 'far fa-fw fa-people-arrows',
               url: '/maintenance/adjustresource',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TRT-CR', 'MTC-TRT-AP', 'MTC-TRT-ED', 'MTC-TRT-DL', 'MTC-TRT-VW'])) {
            childItemArrayC.push({
               caption: 'Tool Type',
               icon: 'far fa-fw fa-wrench',
               url: '/maintenance/tooltype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TR-CR', 'MTC-TR-AP', 'MTC-TR-ED', 'MTC-TR-DL', 'MTC-TR-VW'])) {
            childItemArrayC.push({
               caption: 'Tool',
               icon: 'far fa-fw fa-tools',
               url: '/maintenance/tool',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-ATR-CR', 'MTC-ATR-AP', 'MTC-ATR-ED', 'MTC-ATR-DL', 'MTC-ATR-VW'])) {
            childItemArrayC.push({
               caption: 'Adjust Tool Rate',
               icon: 'far fa-fw fa-exchange-alt',
               url: '/maintenance/adjusttool',
            });
         }

         var childItemArrayD = [];
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TM-CR', 'MTC-TM-AP', 'MTC-TM-ED', 'MTC-TM-DL', 'MTC-TM-VW'])) {
            childItemArrayD.push({
               caption: 'Activity Type',
               icon: 'far fa-fw fa-pencil-ruler',
               url: '/maintenance/activitytype',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TM-CR', 'MTC-TM-AP', 'MTC-TM-ED', 'MTC-TM-DL', 'MTC-TM-VW'])) {
            childItemArrayD.push({
               caption: 'Strategy',
               icon: 'far fa-fw fa-directions',
               url: '/maintenance/strategy',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TM-CR', 'MTC-TM-AP', 'MTC-TM-ED', 'MTC-TM-DL', 'MTC-TM-VW'])) {
            childItemArrayD.push({
               caption: 'Client',
               icon: 'far fa-fw fa-user-tag',
               url: '/maintenance/tenant',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-TM-CR', 'MTC-TM-AP', 'MTC-TM-ED', 'MTC-TM-DL', 'MTC-TM-VW'])) {
            childItemArrayD.push({
               caption: 'Team',
               icon: 'far fa-fw fa-user-friends',
               url: '/maintenance/team',
            });
         }

         var childItemArrayE = [];
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-WH-CR', 'MTC-WH-AP', 'MTC-WH-ED', 'MTC-WH-DL', 'MTC-WH-VW'])) {
            childItemArrayE.push({
               caption: 'Warehouses',
               icon: 'far fa-fw fa-home',
               url: '/maintenance/warehouses',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-ST-CR', 'MTC-ST-AP', 'MTC-ST-ED', 'MTC-ST-DL', 'MTC-ST-VW'])) {
            childItemArrayE.push({
               caption: 'Storerooms',
               icon: 'far fa-fw fa-door-closed',
               url: '/maintenance/storerooms',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-IS-CR', 'MTC-IS-AP', 'MTC-IS-ED', 'MTC-IS-DL', 'MTC-IS-VW'])) {
            childItemArrayE.push({
               caption: 'Isles',
               icon: 'far fa-fw fa-grip-lines',
               url: '/maintenance/isles',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-RO-CR', 'MTC-RO-AP', 'MTC-RO-ED', 'MTC-RO-DL', 'MTC-RO-VW'])) {
            childItemArrayE.push({
               caption: 'Rows',
               icon: 'far fa-fw fa-sitemap',
               url: '/maintenance/rows',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-BI-CR', 'MTC-BI-AP', 'MTC-BI-ED', 'MTC-BI-DL', 'MTC-BI-VW'])) {
            childItemArrayE.push({
               caption: 'Bins',
               icon: 'far fa-fw fa-dumpster',
               url: '/maintenance/bins',
            });
         }

         var childItemArrayF = [];
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-PC-CR', 'MTC-PC-AP', 'MTC-PC-ED', 'MTC-PC-DL', 'MTC-PC-VW'])) {
            childItemArrayF.push({
               caption: 'Part Category',
               icon: 'far fa-fw fa-sitemap',
               url: '/maintenance/partcategory',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-PRT-CR', 'MTC-PRT-AP', 'MTC-PRT-ED', 'MTC-PRT-DL', 'MTC-PRT-VW', 'MTC-PRT-REC'])) {
            childItemArrayF.push({
               caption: 'Manage Parts',
               icon: 'far fa-fw fa-wrench',
               url: '/maintenance/part',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-REQ-CR', 'MTC-REQ-AP', 'MTC-REQ-ED', 'MTC-REQ-DL', 'MTC-REQ-VW'])) {
            childItemArrayF.push({
               caption: 'Stock Requisition',
               icon: 'far fa-fw fa-shopping-basket',
               url: '/maintenance/stockrequisition',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-RET-VW', 'MTC-RET-COLL', 'MTC-RET-RET'])) {
            childItemArrayF.push({
               caption: 'Collect/Return Parts',
               icon: 'far fa-fw fa-exchange-alt',
               url: '/maintenance/workorder/collection',
            });
         }

         var childItemArrayG = [];
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-UPS-COMP', 'MTC-UPS-ED', 'MTC-UPS-DL', 'MTC-UPS-VW'])) {
            childItemArrayG.push({
               caption: 'Assets Pending Setup',
               icon: 'far fa-fw fa-tachometer-alt',
               url: '/maintenance/usage',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'MTC-ALL-MANAGER', 'MTC-ATRT-ADD', 'MTC-ATRT-REM', 'MTC-ATRT-VW'])) {
            childItemArrayG.push({
               caption: 'Assets Tracking Active',
               icon: 'far fa-fw fa-chart-line',
               url: '/maintenance/usage/active',
            });
         }

         var childItemArrayH = [];
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'Requests',
               icon: 'far fa-fw fa-shopping-basket',
               url: '/maintenance/requisition',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'Activities',
               icon: 'far fa-fw fa-wrench',
               url: '/maintenance/activity',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'Triggered Assets',
               icon: 'far fa-fw fa-object-group',
               url: '/maintenance/group',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'Work Orders',
               icon: 'far fa-fw fa-briefcase',
               url: '/maintenance/workorder',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'Schedule',
               icon: 'far fa-fw fa-calendar-alt',
               url: '/maintenance/schedule',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'Pick Work Order',
               icon: 'far fa-fw fa-hand-pointer',
               url: '/maintenance/pickworkorder/null',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'My Work Orders',
               icon: 'far fa-fw fa-user-edit',
               url: '/maintenance/workorder/owner',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN'])) {
            childItemArrayH.push({
               caption: 'Job Card Assessment',
               icon: 'far fa-fw fa-clipboard-check',
               url: '/maintenance/jobcard/jobcard-assessment',
            });
         }

         menuArray.push({
            caption: 'Maintenance',
            icon: 'far fa-fw fa-folder',
            children: [
               {
                  caption: 'Setup',
                  icon: 'far fa-fw fa-folder',
                  children: [
                     {
                        caption: 'Resources',
                        icon: 'far fa-fw fa-folder',
                        children: [
                           {
                              caption: 'Labour Resources',
                              icon: 'far fa-fw fa-folder',
                              children: childItemArrayA,
                           },
                           {
                              caption: 'Asset Resources',
                              icon: 'far fa-fw fa-folder',
                              children: childItemArrayB,
                           },
                           {
                              caption: 'Tool Resources',
                              icon: 'far fa-fw fa-folder',
                              children: childItemArrayC,
                           },
                        ],
                     },
                     {
                        caption: 'Activity Type',
                        icon: 'far fa-fw fa-pencil-ruler',
                        url: '/maintenance/activitytype',
                     },
                     {
                        caption: 'Strategy',
                        icon: 'far fa-fw fa-directions',
                        url: '/maintenance/strategy',
                     },
                     {
                        caption: 'Client',
                        icon: 'far fa-fw fa-user-tag',
                        url: '/maintenance/tenant',
                     },
                     {
                        caption: 'Team',
                        icon: 'far fa-fw fa-user-friends',
                        url: '/maintenance/team',
                     },
                  ],
               },
               {
                  caption: 'Inventory Setup',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayE,
               },
               {
                  caption: 'Parts',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayF,
               },
               {
                  caption: 'Asset Usage Monitoring',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayG,
               },
               {
                  caption: 'Work Order',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayH,
               },
               {
                  caption: 'Reports',
                  icon: 'far fa-fw fa-print',
                  url: '/maintenance/reportdashboard',
               },
            ],
         });

         childItemArrayA = [];
         childItemArrayB = [];
         childItemArrayC = [];
      }

      // ============================================================ ERP Integration ============================================================
      if (
         this.authService.roleMatch([
            'SYSTEM-ADMIN',
            'INT-ST1-VW',
            'INT-ST2-VW',
            'INT-ST3-VW',
            'INT-ST4-VW',
            'INT-EXT-VW',
            'INT-ARC-VW',
            'INT-ACC-VW',
            'INT-ASS-VW',
            'INT-SUP-VW',
            'INT-ERR-VW',
         ])
      ) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-SCNA-VW'])) {
            childItemArrayA.push({
               caption: 'Approved Assets',
               icon: 'far fa-fw fa-cogs',
               url: '/scan/scanintegrated',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-SERR-VW'])) {
            childItemArrayA.push({
               caption: 'Errors',
               icon: 'far fa-fw fa-exclamation-circle',
               url: '/integration/errors',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-ST1-VW', 'INT-ST2-VW', 'INT-ST3-VW', 'INT-ST4-VW'])) {
            childItemArrayB.push({
               caption: 'Asset Invoice Imports',
               icon: 'far fa-fw fa-flag',
               url: 'integration/importsNormal',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-ARC-VW'])) {
            childItemArrayB.push({
               caption: 'Archived Invoices',
               icon: 'far fa-fw fa-archive',
               url: '/integration/importsNormalArchive',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-ST1-VW', 'INT-ST2-VW', 'INT-ST3-VW', 'INT-ST4-VW'])) {
            childItemArrayB.push({
               caption: 'Discarded Invoices',
               icon: 'far fa-fw fa-trash',
               url: 'integration/importsNormalDiscard',
            });
         }

         // if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-SCNA-VW'])) {
         childItemArrayB.push({
            caption: 'Asset Journal Imports',
            icon: 'far fa-fw fa-adjust',
            url: '/integration/asset-journal-imports',
         });
         // }
         // if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-SCNA-VW'])) {
         childItemArrayB.push({
            caption: 'Asset Sales Imports',
            icon: 'far fa-fw fa-money-bill',
            url: '/integration/asset-sales-imports',
         });
         // }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-ACC-VW'])) {
            childItemArrayC.push({
               caption: 'Accounts',
               icon: 'far fa-fw fa-cogs',
               url: 'integration/accounts',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-ASS-VW'])) {
            childItemArrayC.push({
               caption: 'Assets',
               icon: 'far fa-fw fa-cogs',
               url: '/integration/assets',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-SUP-VW'])) {
            childItemArrayC.push({
               caption: 'Suppliers',
               icon: 'far fa-fw fa-cogs',
               url: '/integration/suppliers',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INT-ERR-VW'])) {
            childItemArrayC.push({
               caption: 'Errors',
               icon: 'far fa-fw fa-exclamation-circle',
               url: '/integration/errors',
            });
         }

         menuArray.push({
            caption: 'ERP Integration',
            icon: 'far fa-fw fa-folder',
            children: [
               {
                  caption: 'Scan Integration',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayA,
               },
               {
                  caption: 'ERP Imports',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayB,
               },
               {
                  caption: 'Integration Audit',
                  icon: 'far fa-fw fa-folder',
                  children: childItemArrayC,
               },
            ],
         });

         childItemArrayA = [];
         childItemArrayB = [];
         childItemArrayC = [];
      }

      // ============================================================ Insurance ============================================================
      if (
         this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-VW', 'INS-POL-VW', 'INS-CON-VW', 'INS-GR-VW', 'INS-LK-VW', 'INS_REG-VW', 'INS-PEN-VW', 'INS-CLM-VW', 'INS-RP', 'INS-PR'])
      ) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-VW'])) {
            childItemArrayA.push({
               caption: 'Insurer',
               icon: 'far fa-fw fa-user',
               url: '/insurance/insurer',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-POL-VW'])) {
            childItemArrayA.push({
               caption: 'Policies',
               icon: 'far fa-fw fa-cogs',
               url: '/insurance/policy',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-CON-VW'])) {
            childItemArrayA.push({
               caption: 'Contacts',
               icon: 'far fa-fw fa-users',
               url: '/insurance/ins-contact',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-GR-VW'])) {
            childItemArrayA.push({
               caption: 'Groups',
               icon: 'far fa-fw fa-users-cog',
               url: '/insurance/ins-group',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-LK-VW'])) {
            childItemArrayA.push({
               caption: 'Link Assets to Groups',
               icon: 'far fa-fw fa-cogs',
               url: '/insurance/ins-assets',
            });
         }

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS_REG-VW'])) {
            childItemArrayB.push({
               caption: 'Insurance Register',
               icon: 'far fa-fw fa-chart-line',
               url: '/insurance/insurance-register',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-PEN-VW'])) {
            childItemArrayB.push({
               caption: 'Pending List',
               icon: 'far fa-fw fa-balance-scale',
               url: '/insurance/pending-list',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-CLM-VW'])) {
            childItemArrayB.push({
               caption: 'Claim Processing',
               icon: 'far fa-fw fa-check',
               url: '/insurance/claim',
            });
         }

         childItemArrayC.push({
            caption: 'Configure',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });
         childItemArrayC.push({
            caption: 'Processing',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayB,
         });
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-RP', 'INS-PR'])) {
            childItemArrayC.push({
               caption: 'Reports',
               icon: 'far fa-fw fa-print',
               url: '/insurance/ins-report',
            });
         }

         menuArray.push({
            caption: 'Insurance',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayC,
         });

         childItemArrayA = [];
         childItemArrayB = [];
         childItemArrayC = [];
      }

      // ============================================================ Warranty Management ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WAR-TP-VW', 'WAR-PROV-VW', 'WAR-CON-VW', 'WAR-VW', 'WAR-RP'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WAR-TP-VW'])) {
            childItemArrayA.push({
               caption: 'Types',
               icon: 'far fa-fw fa-paperclip',
               url: '/warranty/types',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WAR-PROV-VW'])) {
            childItemArrayA.push({
               caption: 'Providers',
               icon: 'far fa-fw fa-truck',
               url: '/warranty/providers',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WAR-CON-VW'])) {
            childItemArrayA.push({
               caption: 'Contractors',
               icon: 'far fa-fw fa-hard-hat',
               url: '/warranty/contractors',
            });
         }

         childItemArrayB.push({
            caption: 'Setup',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayB,
         });

         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WAR-VW'])) {
            childItemArrayB.push({
               caption: 'All Warranties',
               icon: 'far fa-fw fa-list-alt',
               url: '/warranty/all',
            });
         }
         // if (this.authService.roleMatch(['SYSTEM-ADMIN', 'INS-VW'])) {
         childItemArrayB.push({
            caption: 'Reports',
            icon: 'far fa-fw fa-print',
            url: '/warranty/reports',
         });
         // }

         menuArray.push({
            caption: 'Warranty Management',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayB,
         });

         childItemArrayA = [];
         childItemArrayB = [];
      }

      // ============================================================ Booking Management ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BOOKING-MANAGER'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BOOKING-MANAGER'])) {
            childItemArrayA.push({
               caption: 'Booking',
               icon: 'far fa-fw fa-exchange-alt',
               url: '/bookingManagement/bookings',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BOOKING-MANAGER'])) {
            childItemArrayA.push({
               caption: 'Clients',
               icon: 'far fa-fw fa-user',
               url: '/bookingManagement/client',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BOOKING-MANAGER'])) {
            childItemArrayA.push({
               caption: 'Asset',
               icon: 'far fa-fw fa-project-diagram',
               url: '/bookingManagement/bmm-asset',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BOOKING-MANAGER'])) {
            childItemArrayA.push({
               caption: 'Monitoring',
               icon: 'far fa-fw fa-tachometer-alt',
               url: '/bookingManagement/monitorBookings',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'BOOKING-MANAGER'])) {
            childItemArrayA.push({
               caption: 'Reports',
               icon: 'far fa-fw fa-print',
               url: '/bookingManagement/reportsBookings',
            });
         }

         menuArray.push({
            caption: 'Booking Management',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         childItemArrayA = [];
      }

      // ============================================================ Workflow ============================================================
      if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WF-SET-VW', 'WF-VW', 'WF-APP-V', 'WF-REJ-VW'])) {
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WF-SET-VW'])) {
            childItemArrayA.push({
               caption: 'Setup',
               icon: 'far fa-fw fa-cog',
               url: '/workflow/setup',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WF-VW'])) {
            childItemArrayA.push({
               caption: 'All Workflows',
               icon: 'far fa-fw fa-list-alt',
               url: '/workflow/all',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WF-APP-V'])) {
            childItemArrayA.push({
               caption: 'Approvals',
               icon: 'far fa-fw fa-check',
               url: '/workflow/open',
            });
         }
         if (this.authService.roleMatch(['SYSTEM-ADMIN', 'WF-REJ-VW'])) {
            childItemArrayA.push({
               caption: 'Rejections to Review',
               icon: 'far fa-fw fa-thumbs-down',
               url: '/workflow/rejected',
            });
         }

         menuArray.push({
            caption: 'Workflow',
            icon: 'far fa-fw fa-folder',
            children: childItemArrayA,
         });

         childItemArrayA = [];
      }

      const jsonResult = { type: 'setMenu', payload: { menu: menuArray } };
      return jsonResult;
   }
}
